import ApiService from '@/assets/js/apiService'; // 引入 ApiService 實例
const apiService = new ApiService();
import { createRouter, createWebHistory } from 'vue-router'

import mainLayoutRouter from '@/router/mainLayoutRouter.js'


import Login from '@/views/Login.vue';
import MainLayout from '@/views/MainLayout.vue';
import createIntake from '@/views/outsideIntake/createIntake.vue'
import reportSubmitted from '@/views/outsideIntake/reportSubmitted.vue'
import testReport from '@/views/testReport/testReportUpload.vue'
import uploadSubmitted from '@/views/testReport/uploadSubmitted.vue'
import xRayView from '@/views/testReport/x-ray-view.vue'
import devSetting from '@/views/devSetting.vue'
import devImport from '@/views/devImport.vue'
import devImportSpecies from '@/views/devImportSpecies.vue'
// import teachingManual from '@/views/teachingManual.vue'
import surgery from '@/views/healthRecord/tabs/surgery/surgeryIndex.vue'
import devIntake from '@/views/dev/create.vue'
import devPdfParser from '@/views/dev/devPdfParser.vue'
import PageNotDeveloped from '@/views/PageNotDeveloped.vue'; // 新增這一行
const routes = [{
  path: '/',
  component: MainLayout,
  children: mainLayoutRouter,
  meta: { requiresAuth: true }, // 需要登录验证
}, {
  path: '/login',
  name: 'Login',
  component: Login
}, { //手術
  path: '/surgery/:id/:sid',
  name: 'surgery',
  component: surgery
}, {
  path: '/createIntake',
  name: 'createIntake',
  component: createIntake
}, {
  path: '/reportSubmitted/:serial_no',
  name: 'reportSubmitted',
  component: reportSubmitted
}, {
  path: '/testReport/:id',
  name: 'testReport',
  component: testReport
}, {
  path: '/uploadSubmitted',
  name: 'uploadSubmitted',
  component: uploadSubmitted
}, {
  path: '/x-ray/:id/:path',
  name: 'x-ray',
  component: xRayView
}, {
  path: '/dev/setting',
  name: 'dev-setting',
  component: devSetting
},
{
  path: '/dev/import',
  name: 'dev-import',
  component: devImport
},
{
  path: '/dev/devImportSpecies',
  name: 'dev-importSpecies',
  component: devImportSpecies
},
{
  path: '/dev/intake',
  name: 'dev-intake',
  component: devIntake
},
{
  path: '/dev/pdfParser',
  name: 'dev-pdfParser',
  component: devPdfParser
},
// {
//   path: '/teachingManual',
//   name: 'teachingManual',
//   component: teachingManual
// },
{
  path: '/:catchAll(.*)', // 匹配所有未定義的路由
  name: 'PageNotDeveloped',
  component: PageNotDeveloped,
}]

const router = createRouter({
  base: process.env.VUE_APP_BASE_APP_URL,
  history: createWebHistory(process.env.VUE_APP_BASE_APP_URL),
  routes,
  mode: 'history'
})

// 模拟登录状态
const isLoggedIn = () => {
  // 替换为实际的登录逻辑，如从 Vuex、localStorage 中获取状态
  const userData = apiService.users.getUserData()
  if (!userData) {
    return false
  }
  return true
};

// 路由守卫
router.beforeEach((to, from, next) => {
  // 判断路由是否需要登录验证
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (isLoggedIn()) {
      // 已登录，允许进入
      next();
    } else {
      // 未登录，重定向到登录页
      next({ name: 'Login' });
    }
  } else {
    // 不需要登录验证，直接进入
    next();
  }
});

export default router
